var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-burger';
                    var viewUrl = 'sprite.svg#view-icon-burger';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-burger#icon-burger';
                            viewUrl = 'sprite.svg?icon-burger#view-icon-burger';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 35 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };